var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttestationFrameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 16,
    viewBox: "0 0 90 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4326 15.7352V0.371338H72.1907V15.7352H68.4326Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4326 15.7352V0.371338H72.1907V15.7352H68.4326Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1757 0.371338H89.8532V15.7352H86.8058L79.1266 6.05636L79.1875 15.7352H75.4902V0.371338H78.619L86.2982 9.98911L86.1765 0.371338H86.1757Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1757 0.371338H89.8532V15.7352H86.8058L79.1266 6.05636L79.1875 15.7352H75.4902V0.371338H78.619L86.2982 9.98911L86.1765 0.371338H86.1757Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1969 15.7352V3.85527H24.8452V0.371338H35.308V3.8561H31.9561V15.736H28.1977L28.1969 15.7352Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1969 15.7352V3.85527H24.8452V0.371338H35.308V3.8561H31.9561V15.736H28.1977L28.1969 15.7352Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.731934 8.11465C0.731934 3.3462 4.36836 0.0858154 8.95978 0.0858154C11.7227 0.0858154 14.2216 1.20616 15.8263 3.611L12.5148 5.34268C11.6207 4.12004 10.4625 3.46828 9.00008 3.46828C6.41978 3.46828 4.61185 5.4854 4.61185 8.13444C4.61185 10.7835 6.58263 12.7602 8.87834 12.7602C10.7677 12.7602 12.129 11.6192 12.3725 10.1111V10.0905H9.16296V7.19727H16.5781V7.849C16.5781 12.8617 13.5915 15.9999 8.83803 15.9999C4.34781 15.9999 0.731934 12.7602 0.731934 8.11465Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.731934 8.11465C0.731934 3.3462 4.36836 0.0858154 8.95978 0.0858154C11.7227 0.0858154 14.2216 1.20616 15.8263 3.611L12.5148 5.34268C11.6207 4.12004 10.4625 3.46828 9.00008 3.46828C6.41978 3.46828 4.61185 5.4854 4.61185 8.13444C4.61185 10.7835 6.58263 12.7602 8.87834 12.7602C10.7677 12.7602 12.129 11.6192 12.3725 10.1111V10.0905H9.16296V7.19727H16.5781V7.849C16.5781 12.8617 13.5915 15.9999 8.83803 15.9999C4.34781 15.9999 0.731934 12.7602 0.731934 8.11465Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 15.7352V0.371338H22.9144V15.7352H19.1562Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 15.7352V0.371338H22.9144V15.7352H19.1562Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4131 12.516C42.0772 12.516 40.1063 10.682 40.1063 8.0536C40.1063 5.56789 41.9958 3.59122 44.4544 3.59122C45.6651 3.59122 46.722 4.05074 47.4912 4.81138C47.862 3.62338 48.4395 2.51212 49.2068 1.51883C47.8628 0.618766 46.2277 0.106445 44.474 0.106445C39.964 0.106445 36.2256 3.48893 36.2256 8.03298C36.2256 12.8014 39.9837 15.9999 44.4131 15.9999C46.1817 15.9999 47.8291 15.5033 49.1805 14.6206C48.4222 13.6281 47.8506 12.5102 47.4845 11.3074C46.7039 12.0647 45.6314 12.516 44.4131 12.516Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4131 12.516C42.0772 12.516 40.1063 10.682 40.1063 8.0536C40.1063 5.56789 41.9958 3.59122 44.4544 3.59122C45.6651 3.59122 46.722 4.05074 47.4912 4.81138C47.862 3.62338 48.4395 2.51212 49.2068 1.51883C47.8628 0.618766 46.2277 0.106445 44.474 0.106445C39.964 0.106445 36.2256 3.48893 36.2256 8.03298C36.2256 12.8014 39.9837 15.9999 44.4131 15.9999C46.1817 15.9999 47.8291 15.5033 49.1805 14.6206C48.4222 13.6281 47.8506 12.5102 47.4845 11.3074C46.7039 12.0647 45.6314 12.516 44.4131 12.516Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8842 0.106445C55.054 0.106445 52.5279 1.43881 51.0382 3.55408C50.155 4.80973 49.6357 6.34091 49.6357 8.03299C49.6357 9.72504 50.1531 11.3536 51.03 12.6076C52.5165 14.7336 55.0375 15.9999 57.8233 15.9999C62.354 15.9999 66.0925 12.7396 66.0925 8.07341C66.0925 3.40725 62.3745 0.106445 57.8842 0.106445ZM57.8233 12.516C55.4873 12.516 53.5167 10.682 53.5167 8.0536C53.5167 5.56789 55.406 3.59123 57.8645 3.59123C60.323 3.59123 62.2126 5.54728 62.2126 8.07421C62.2126 10.6012 60.323 12.516 57.8241 12.516H57.8233Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8842 0.106445C55.054 0.106445 52.5279 1.43881 51.0382 3.55408C50.155 4.80973 49.6357 6.34091 49.6357 8.03299C49.6357 9.72504 50.1531 11.3536 51.03 12.6076C52.5165 14.7336 55.0375 15.9999 57.8233 15.9999C62.354 15.9999 66.0925 12.7396 66.0925 8.07341C66.0925 3.40725 62.3745 0.106445 57.8842 0.106445ZM57.8233 12.516C55.4873 12.516 53.5167 10.682 53.5167 8.0536C53.5167 5.56789 55.406 3.59123 57.8645 3.59123C60.323 3.59123 62.2126 5.54728 62.2126 8.07421C62.2126 10.6012 60.323 12.516 57.8241 12.516H57.8233Z",
    fill: "black",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_1714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.3333,
    height: 16,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttestationFrameLogo);
export default __webpack_public_path__ + "static/media/attestation-frame-logo.848dc303ce89e8263e8a1df563e3d360.svg";
export { ForwardRef as ReactComponent };